// extracted by mini-css-extract-plugin
export default {"form":"ClinicaForm_form__wBVBT","ativarAviso":"ClinicaForm_ativarAviso__PSEzE"};